import { Typography } from '../../../components/Typography'
import { hsColumns } from '../constants'
import { Table } from '../../../components/Table'
import { useEffect, useState } from 'react'
import { ReactComponent as ArrowDown16 } from '../../../assets/svg/ArrowDown16.svg'
import { ReactComponent as ArrowRight16 } from '../../../assets/svg/ArrowRight16.svg'
import '../styles.scss'
import moment, { Moment } from 'moment'
import { useSavingGoalsContext } from '../Providers/SavingGolasContextProvider'
import { THSSavingGoalsTable } from '../types'
import { useSavingGoalsHistoryContext } from '../Providers/SavingGoalsHistoryContextProvider'

type HealthSystemTableProps = {
  period: Moment
}

export const HealthSystemTable = ({ period }: HealthSystemTableProps) => {
  const [expandedRowKeys, setExpandedRowKeys] = useState<string[]>([])
  const [firstLoad, setFirstLoad] = useState<boolean>(true)

  const {
    actions: { onChangeLineData, handleTableChange, handleChangePageSize },
    state: {
      hsTableData,
      pageInfo,
      hsTotalNumber,
      disableTableActions,
      highlightErrors,
      canEditHSSavingGoals,
      canSeeHistory
    }
  } = useSavingGoalsContext()

  const {
    actions: { selectItemToShowHistory }
  } = useSavingGoalsHistoryContext()

  useEffect(() => {
    if (period) setFirstLoad(true)
  }, [period])
  useEffect(() => {
    if (hsTableData.length && firstLoad) {
      setExpandedRowKeys([hsTableData[0]?.uuid])
      setFirstLoad(false)
    }
  }, [firstLoad, hsTableData])

  const columns = hsColumns(
    {
      disableActions: disableTableActions,
      hideHistoryColumn: !canSeeHistory,
      isEditableSavingGoal:
        period.startOf('year').isSameOrAfter(moment().startOf('year')) &&
        canEditHSSavingGoals
    },
    onChangeLineData,
    selectItemToShowHistory,
    highlightErrors
  )

  return (
    <div className="column gap-24">
      <Typography.Headline5>Health systems</Typography.Headline5>
      <Table<THSSavingGoalsTable>
        columns={columns}
        dataSource={hsTableData}
        onChange={handleTableChange}
        onChangePage={handleChangePageSize}
        pageSize={pageInfo.pageSize}
        expandable={{
          defaultExpandAllRows: false,
          columnWidth: 40,
          expandedRowKeys,
          onExpand: (expanded, record) => {
            if (expanded) setExpandedRowKeys([record.uuid])
            else setExpandedRowKeys([])
          },
          expandIcon: ({ expanded, onExpand, record, expandable }) =>
            expandable && record.children.length ? (
              expanded ? (
                <div
                  className="expand-wrapper row gap-12 align-center"
                  onClick={(e) => onExpand(record, e)}
                >
                  <ArrowDown16 />
                </div>
              ) : (
                <div
                  className="expand-wrapper row gap-12 align-center"
                  onClick={(e) => onExpand(record, e)}
                >
                  <ArrowRight16 />
                </div>
              )
            ) : record.hs_uuid ? null : (
              <div className="empty-expand-wrapper" />
            )
        }}
        pagination={{
          pageSize: pageInfo.pageSize,
          current: pageInfo.pageNumber,
          total: hsTotalNumber
        }}
      />
    </div>
  )
}
